import { get } from '@vueuse/core';
import type { Ref } from 'vue';
import { computed } from 'vue';
import { deepCompareComputed } from '@/composable/deepCompareComputed';
import { useBetBuilderEventExistsQuery } from '@/core/oddsApi/oddsApiType';

export function useBetBuilderExists(matchId: number, isEnabled: Ref<boolean>) {
    const variables = computed(() => ({
        query: {
            id: get(matchId),
        },
    }));

    const { result, onResult } = useBetBuilderEventExistsQuery(
        variables,
        deepCompareComputed(() => ({
            pollInterval: 30000,
            enabled: isEnabled.value,
        })),
    );
    const isBetBuilderMatchExist = computed(() => {
        if (!isEnabled.value) return false;

        return result.value;
    });

    return {
        isBetBuilderMatchExist,
        onResult,
    };
}
